
import { defineComponent, ref } from "vue";
import TrialInfo from "./TrialInfo.vue";
import TrialExpired from "./TrialExpired.vue";
import SubscriptionInfo from "./SubscriptionInfo.vue";
import BillingInfoChange from "./BillingInfoChange.vue";
import SubscriptionChange from "./SubscriptionChange.vue";
import SubscriptionExpired from "./SubscriptionExpired.vue";
import CollapsableContainer from "./CollapsableContainer.vue";
import { useUserStore } from "@/store/user";

export default defineComponent({
  components: {
    TrialInfo,
    TrialExpired,
    SubscriptionExpired,
    SubscriptionInfo,
    BillingInfoChange,
    SubscriptionChange,
    CollapsableContainer,
  },
  setup() {
    const user = useUserStore();
    let loadingShow = ref(false);
    let showBillingInfoChange = ref(false);
    let showSubscriptionChange = ref(false);

    function toggleSubChangeBlock() {
      showBillingInfoChange.value = false;
      showSubscriptionChange.value = !showSubscriptionChange.value;
    }
    function toggleBillingInfoChangeBlock() {
      showSubscriptionChange.value = false;
      showBillingInfoChange.value = !showBillingInfoChange.value;
    }
    function subChangeShowed() {
      if (isTrial() || isExpired() || !isExist()) {
        return true;
      } else {
        return showSubscriptionChange.value;
      }
    }
    function isExist() {
      return user.subscription ? true : false;
    }
    function isTrial() {
      return user.subscription?.isTrial;
    }
    function isExpired() {
      return user.subscription?.state === "expired";
    }

    return {
      loadingShow,
      showBillingInfoChange,
      showSubscriptionChange,
      toggleSubChangeBlock,
      toggleBillingInfoChangeBlock,
      subChangeShowed,
      isExist,
      isTrial,
      isExpired,
    };
  },
});
